import type { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const RadioGroup = ({
  disabled = false,
  helpText,
  id,
  label,
  onChange,
  options,
  optionsClassName = '',
  selectedValue
}: Props) => {
  return (
    <fieldset disabled={disabled}>
      {label && <legend className="block my-1 font-medium text-gray-700">{label}</legend>}
      <div className={optionsClassName ? optionsClassName : 'flex items-start gap-2 flex-wrap'}>
        {options.map(({ className, label: optionLabel, value }) => {
          const optionKey = `${id}-radio-${value}`;
          return (
            <div
              key={optionKey}
              className={`flex items-center py-2 px-3 border border-gray-300 rounded-md shadow-xs ${className}`}>
              <input
                id={optionKey}
                type="radio"
                value={String(value)}
                checked={value === selectedValue}
                onChange={() => onChange(value)}
                className="h-4 w-4 focus:outline-hidden focus:ring-indigo-500 focus:border-indigo-500"
              />
              <label
                htmlFor={optionKey}
                className="ml-2 block leading-6 text-sm font-medium text-gray-700">
                {optionLabel}
              </label>
            </div>
          );
        })}
      </div>
      {helpText && <div className="mt-2 text-sm text-gray-500">{helpText}</div>}
    </fieldset>
  );
};

export default RadioGroup;
